export default __webpack_public_path__ + "static/media/whiteAdd.5ca6ac5a.svg";